module.exports = __webpack_public_path__ + "img/agro_tampa_dosadora_1000ml.1f4a9302.png";